import NutrientViewer from '@nutrient-sdk/viewer'
import hexToRgb from 'hex-rgb'
import { DocumentLabelType, LabelColors } from '../helper/nutrient-label'

type AnnotationPreset = Record<string, unknown>

export const getLabelColor = (labelType: string | DocumentLabelType) => {
  const rgbColor = hexToRgb(LabelColors[labelType])
  const color = new NutrientViewer.Color({
    b: rgbColor.blue,
    g: rgbColor.green,
    r: rgbColor.red,
  })

  return color
}

export interface LabelPresets {
  [key: string]: AnnotationPreset
}
export enum tabFields {
  subject = 1,
  recipientMetadata = 2,
  senderName = 3,
  paymentRecepient = 4,
  paymentIban = 5,
  paymentAmount = 6,
  paymentReference = 7,
  scanMetadata = 8,
  natifMetadata = 9,
  tags = 10,
  senderStreet = 11,
  senderZip = 12,
  senderCity = 13,
  senderEmail = 14,
  senderPhone = 15,
}
export const getLabelPresets = () =>
  Object.keys(DocumentLabelType).reduce<LabelPresets>((presets, labelType) => {
    const color = getLabelColor(labelType)
    return {
      ...presets,
      [labelType]: {
        fillColor: color,
        strokeColor: color,
        opacity: 0.7,
      },
    }
  }, {})

export { DocumentLabelType }
